/**
 * オペレーションタイプ
 */
export const OperationType = {
  // 期中変更
  midterm_change: 'midterm_change',
  // 契約更改
  renewal: 'renewal',
  // 解約
  cancel: 'cancel',
} as const;

